/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type WrapperQueryListChatActivitiesRootQueryVariables = {};
export type WrapperQueryListChatActivitiesRootQueryResponse = {
    readonly viewer: {
        readonly _id: string;
        readonly oid_groups: ReadonlyArray<string | null> | null;
    } | null;
};
export type WrapperQueryListChatActivitiesRootQuery = {
    readonly response: WrapperQueryListChatActivitiesRootQueryResponse;
    readonly variables: WrapperQueryListChatActivitiesRootQueryVariables;
};



/*
query WrapperQueryListChatActivitiesRootQuery {
  viewer {
    _id
    oid_groups
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oid_groups",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "WrapperQueryListChatActivitiesRootQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "WrapperQueryListChatActivitiesRootQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "400727d97585e95a550cb073909d998f",
    "id": null,
    "metadata": {},
    "name": "WrapperQueryListChatActivitiesRootQuery",
    "operationKind": "query",
    "text": "query WrapperQueryListChatActivitiesRootQuery {\n  viewer {\n    _id\n    oid_groups\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = 'c6b230a8e7ca73e7c802ea7e19a03bd6';
export default node;
